import { render, staticRenderFns } from "./FacilityDetail.vue?vue&type=template&id=461f3c2b&"
import script from "./FacilityDetail.vue?vue&type=script&lang=js&"
export * from "./FacilityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports